import Vue from 'vue'
import Vuex from 'vuex'

import ContactFormModule from './contact-form.module'
import AuthModule from './auth.module';
import TestsModule from './tests.module';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    ContactFormModule,
    AuthModule,
    TestsModule
  }
})
